import { startsWith } from 'lodash';
import { styled } from '@mui/material/styles';
import { withFormsy } from 'formsy-react';
import React from 'react';
import PhoneInput from 'react-phone-input-2';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import 'react-phone-input-2/lib/material.css';
import CurrentUser from 'auth/currentUser';
import * as countries from 'i18n-iso-countries';
// import es from 'react-phone-input-2/lang/es.json';
import parsePhoneNumber from 'libphonenumber-js';

const PREFIX = 'PhoneInputFormsy';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(() => ({
  '& .form-control': {
    width: '100%',
  },
  '& .special-label': {
    left: 10,
  },
}));

function PhoneInputFormsy(props) {
  const { name, label, errorMessage, description } = props;
  // Fix country selector to current user's country when input phone number
  const currentCountryCode3 = CurrentUser.getInstance().getCompanyAttr('countryCode');
  const currentCountryCode2 = countries.alpha3ToAlpha2(currentCountryCode3);
  const fixedCountry = currentCountryCode2 ? [currentCountryCode2.toLowerCase()] : [];
  const hasNoCountry = currentCountryCode2 ? false : true;
  const value = props.value || '';

  function changeValue(phone) {
    const withPlus = !phone || startsWith(phone, '+') ? phone : `+${phone}`;
    const phoneNumber = parsePhoneNumber(withPlus);
    const formatted = phoneNumber ? phoneNumber.formatInternational() : withPlus;

    props.setValue(formatted);
    if (props.onChange) {
      props.onChange(formatted);
    }
  }

  const helperText = errorMessage || description;

  return (
    <FormControl error={Boolean(errorMessage)}>
      <Root>
        <PhoneInput
          placeholder=""
          prefix="+"
          disableCountryCode={false}
          countryCodeEditable={true}
          inputProps={{
            name: name,
            autoFocus: false,
          }}
          specialLabel={label}
          enableSearch={hasNoCountry}
          copyNumbersOnly={false}
          enableLongNumbers={true}
          value={value}
          masks={{ cn: '... .... ....' }}
          isValid={() => !errorMessage}
          country={fixedCountry[0] ?? 'gb'}
          onChange={changeValue}
        />
      </Root>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(PhoneInputFormsy));
